import { THEME as t } from "../globals/constants.js";
import o from "../themes/AtriusDark.js";
import h from "../themes/AtriusLight.js";
import m from "../themes/DistechDark.js";
import e from "../themes/DistechLight.js";
import s from "../themes/DLNLight.js";
const i = {
  [t.distechLight]: e,
  [t.distechDark]: m,
  [t.atriusLight]: h,
  [t.atriusDark]: o,
  [t.dlnLight]: s
}, p = (r) => i[r] || i[t.distechLight];
export {
  p as default
};
